import React from "react";
import i18n from "../../../i18n/i18n"; // Import the i18n instance
import PhotoHistoryIcon from "../../shared/icons/PhotoHistoryIcon";
import AnalyticsIcon from "../../shared/icons/AnalyticsIcon";
import SupportIconMenu from "../../shared/icons/SupportIconMenu";
import CarOrderIcon from "../../shared/icons/CarOrderIcon";
import UsersIcon from "../../shared/icons/UsersIcon";
import LupeIcon from "../../shared/icons/LupeIcon";
import LoaderProgress from "../loader-progress/LoaderProgress";
import OrdersIcon from "../../shared/icons/OrdersIcon";
import DraftsIcon from "../../shared/icons/DraftsIcon";
import WalletIcon from "../../shared/icons/WalletIcon";
import SettingsIcon from "../../shared/icons/SettingsIcon";
import GarageIcon from "../../shared/icons/GarageIcon";
import PartnerIcon from "../../shared/icons/PartnerIcon";

const commonNavigation = [
  {
    title: i18n.t('sidebar.mainMenu.analytics'), // Use i18n.t()
    icon: <AnalyticsIcon />,
    link: "/analytics",
  },
  {
    title: i18n.t('sidebar.mainMenu.support'), // Use i18n.t()
    icon: <SupportIconMenu />,
    link: "/support",
  },
];

const clientTopMenu = [
  {
    title: i18n.t('sidebar.mainMenu.orders'), // Use i18n.t()
    icon: <OrdersIcon type={1} />,
    link: "/main",
    children: [],
  },
  {
    title: i18n.t('sidebar.mainMenu.drafts'), // Use i18n.t()
    icon: <DraftsIcon type={1} />,
    link: "/orders/draft",
  },
  {
    title: i18n.t('sidebar.mainMenu.analytics'), // Use i18n.t()
    icon: <AnalyticsIcon type={1} />,
    link: "/analytics",
  },
  {
    title: i18n.t('sidebar.mainMenu.employees'), // Use i18n.t()
    icon: <UsersIcon type={1} />,
    link: "/workers",
  },
  {
    title: i18n.t('sidebar.mainMenu.orderHistory'), // Use i18n.t()
    icon: <PhotoHistoryIcon type={1} />,
    link: "/orders/history",
  },
];

export const getMenuExpeditor = (t) => [
  {
    title: t('sidebar.mainMenu.onboarding'),
    icon: <LoaderProgress type={1} />,
    link: "/onboarding-expeditor",
    content: "border",
    display: "none",
  },
  {
    title: t('sidebar.mainMenu.orderSearch'),
    icon: <LupeIcon type={1} />,
    link: "/orders-search",
  },
  {
    title: t('sidebar.mainMenu.ordersInProgress'),
    icon: <OrdersIcon type={1} />,
    link: "/orders/in-progress",
  },
  {
    title: t('sidebar.mainMenu.drafts'),
    icon: <DraftsIcon type={1} />,
    link: "/orders/draft",
  },
  {
    title: t('sidebar.mainMenu.fleet'),
    icon: <GarageIcon type={1} />,
    link: "/cars",
  },
  {
    title: t('sidebar.mainMenu.drivers'),
    icon: <UsersIcon />,
    link: "/drivers",
  },
  {
    title: t('sidebar.mainMenu.analytics'),
    icon: <AnalyticsIcon type={1} />,
    link: "/analytics",
  },
  {
    title: t('sidebar.mainMenu.employees'),
    icon: <UsersIcon type={1} />,
    link: "/workers",
  },
  // {
  //   title: i18n.t('sidebar.mainMenu.balance'),
  //   icon: <WalletIcon type={1}/>,
  //   link: "/balance/lists",
  // },
  {
    title: t('sidebar.mainMenu.settings'),
    icon: <SettingsIcon type={1} />,
    link: "/profile",
  },
];

export const getMenuClient = (t) => [
  {
    title: t('sidebar.mainMenu.onboarding'),
    icon: <LoaderProgress />,
    link: "/onboarding",
    content: "border",
    display: "none",
  },
  {
    title: t('sidebar.mainMenu.orders'),
    icon: <OrdersIcon type={1} />,
    link: "/main",
  },
  {
    title: t('sidebar.mainMenu.drafts'),
    icon: <DraftsIcon type={1} />,
    link: "/orders/draft",
  },
  {
    title: t('sidebar.mainMenu.partners'),
    icon: <PartnerIcon type={1} />,
    link: "/partners",
  },
  {
    title: t('sidebar.mainMenu.analytics'),
    icon: <AnalyticsIcon type={1} />,
    link: "/analytics",
  },
  {
    title: t('sidebar.mainMenu.employees'),
    icon: <UsersIcon type={1} />,
    link: "/workers",
  },
  {
    title: t('sidebar.mainMenu.balance'),
    icon: <WalletIcon type={1} />,
    link: "/balance/lists",
  },
  {
    title: t('sidebar.mainMenu.settings'),
    icon: <SettingsIcon type={1} />,
    link: "/profile",
  },
];
